import React, { Component } from "react";
import style from "./EditSystemUser.module.css";
import { Button } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../../utils/Api";
import history from "../../utils/history";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { connect } from "react-redux";
import { fetchDropdownList, fetchUserDetails } from "../../redux";
import { Select } from "antd";
import swal from "sweetalert";
import { isEmpty } from "../../utils/CommonUtil";
import { NAME_MESSAGE, NAME_REGEX } from "../../utils/RegexConstants";

const { Option } = Select;

export class EditSystemUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      first_name: "",
      last_name: "",
      isUserOnline: false,
      system_role: [],
      system_access: 1,
      user_id:"",
      approval_list_access: 1,
      isBillingPractitioner: 0,
      mediswitch_username: "",
      mediswitch_password: "",
     // package_code: "SWITCHON",
      isScreenLoaded: false,
      lk_related_party_role_id:""
    };
  }

  componentDidMount = async() => {
    document.title = 'Edit System User - TechToMedix';
    if (this.props.match.params.id) {
        this.setState({
          user_id: this.props.match.params.id,
        });
        await this.props.fetchUserDetails(this.props.match.params.id);

        if(!this.props.userDetailsData.loading && !this.props.userDetailsData.error){
            let userDetails = this.props.userDetailsData.userDetails;
            if(!isEmpty(userDetails)){
              this.setState({
                  first_name: userDetails.first_name,
                  last_name: userDetails.last_name,
                  system_access: userDetails.isSystemUser,
                  approval_list_access: userDetails.approver,
                  isUserOnline: userDetails.isUserOnline,
                  primary_system_role: userDetails.role_id,
                  system_role: userDetails.assigned_roles,
                  lk_related_party_role_id:userDetails.lk_related_party_role_id
              })

              if(!isEmpty(userDetails.practiseModel)){
                this.setState({
                  isBillingPractitioner: (userDetails.practiseModel.isBillingPractitioner === 1) ? 1 : 0,
                  mediswitch_username: userDetails.practiseModel.mediswitch_username,
                  mediswitch_password: userDetails.practiseModel.mediswitch_password,
                 // package_code: userDetails.practiseModel.package_code,
              })
              }

            }
        }
        // else{
        //   history.goBack();
        // }
      }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 2000);
  }

  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
  };

  handleCheckbox = (event) => {
    event.persist();
    const val = event.target.checked;
    const name = event.target.name;
    this.setState(
      {
          [name]: val ? 1 : 0,
      });
      if(name === "system_access" && val === false){
        this.showSystemWarning();
     }
  };

  showSystemWarning = async() => {
    const continueFlag = await swal("User will no longer have system access. Do you want to continue?", {
        className: "logout-swal-modal",
        buttons: ["Cancel", "Continue"],
      });
      if (!continueFlag) {
        this.setState({
            system_access: 1,
          });
      }
  }

  handleInputSystemRole = (arr) => {

    this.setState({
      system_role: arr,
    });
    if(arr.length === 0 || arr.indexOf(this.state.primary_system_role) === -1){
      this.setState({
        primary_system_role: "",
      });
    }
  };

  goBack = () => {
    history.goBack()
  }
  
  render() {
    const DropDownData = this.props.dropdownListData &&
     this.props.dropdownListData.dropdownList;

     const userDetails = this.props.userDetailsData && this.props.userDetailsData.userDetails;
     const systemRoleOptions =
     DropDownData && DropDownData.role &&
     DropDownData.role.filter((opt) => opt.role_id !== 1)
     .filter((opt)=>{
       if(Number(this.state.lk_related_party_role_id) !== 3){
        return (opt.role_id !== 2)
       }else{
         return true
       }
     }).map((element, index) => (
        <Option key={index} value={element.role_id}>
          {element.role_name}
        </Option>
      ));
      
      
      const primarySystemRoleOptions = 
      DropDownData && DropDownData.role &&
     DropDownData.role.map((element, index) => {
     if(this.state.system_role && 
      this.state.system_role.length > 0 && 
      this.state.system_role.indexOf(element.role_id) > -1){
        return (
        <option key={index} value={element.role_id}>
          {element.role_name}
        </option>
        )
     }
    });

    //console.log("state", this.state)

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <React.Fragment>
        <Formik
          initialValues={this.state}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            first_name: Yup.string().trim()
            .matches(NAME_REGEX, NAME_MESSAGE)
            .required("First Name is required!"),
            last_name: Yup.string().trim()
            .matches(NAME_REGEX, NAME_MESSAGE)
            .required("Last Name is required!"),
            primary_system_role: Yup.number().required("Primary System role is required!"),
            system_role: Yup.array().required("Select at least one role!"),
            mediswitch_username: Yup.string().trim().when("isBillingPractitioner", {
              is: (value) => value === 1,
              then: Yup.string()
                .required("Username is required").nullable(),
                otherwise: Yup.string().nullable(),
            }),
            mediswitch_password: Yup.string().trim().when("isBillingPractitioner", {
              is: (value) => value === 1,
              then: Yup.string()
                .required("Password is required").nullable(),
                otherwise: Yup.string().nullable(),
            }),
            // package_code: Yup.string().when("isBillingPractitioner", {
            //   is: (value) => value === 1,
            //   then: Yup.string()
            //     .required("Package code is required").nullable(),
            //     otherwise: Yup.string().nullable(),
            // }),
          })}
          onSubmit={async (data) => {
              this.setState({
                isLoading: true,
              });
              // Paylaod
              const payload = {
                first_name: data.first_name.trim(),
                last_name: data.last_name.trim(),
                isSystemUser: data.system_access,
                approver: data.approval_list_access,
                user_id: this.state.user_id,
                assigned_roles: this.state.system_role,
                role_id: this.state.primary_system_role,
              };

              payload.isBillingPractitioner = this.state.isBillingPractitioner;
              //if(this.state.isBillingPractitioner === 1){
                payload.mediswitch_username = this.state.mediswitch_username;
                payload.mediswitch_password = this.state.mediswitch_password;
               // payload.package_code = this.state.package_code;
             // }
              //console.log("Edit account payload", payload);

              // Headers
              const headers = {
                Authorization:
                  "Bearer " +
                  JSON.parse(localStorage.getItem("USER_INFO")).token,
              };
                this.setState({
                      errorMessage: "",
                    });
              try {
                const response = await api.put("user/manage", payload, {
                  headers: headers,
                });
                if (response.status === 200) {
                  this.setState({
                    isLoading: false,
                    successMessage:
                      "User details updated successfully!",
                  });
                }
                setTimeout(() => {
                  this.setState({
                    successMessage: "",
                  });
                  history.push("/users")
                }, 2500);
              } catch (error) {
                if (error.response) {
                  console.log("error.response", error.response);
                  this.setState({
                    isLoading: false,
                    errorMessage: error.response.data.message,
                  });
                  // setTimeout(() => {
                  //   this.setState({
                  //     errorMessage: "",
                  //   });
                  // }, 2000);
                }
              }
            
          }}
          >
          {({ errors, status, touched }) => (
            <div className={style.editAccWrapper}>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Edit System User</h3>
                </div>
                <div className="col-lg-12 intro-text">
                  {/* <p className="mb-4">
                    Here the name, email and password can be changed as needed.
                    When the given checkbox is selected for email and password
                    sections, the fields will be enabled to edit the details.
                  </p> */}
                </div>
              </div>
              <Form>
                <div className="form-box-shadow mb-4">
                {this.state.isUserOnline && (
                <div className="row">
                    <div className="col-lg-12">
                      <span class="circle"></span>{" "}{this.state.first_name}{" "}{this.state.last_name} is online. 
                      Any changes will affect the application behavior for the user.
                    </div>
                  </div>)}
                  <div className="row">
                    <div className="col-lg-12">
                      <h4>User Info</h4>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="first_name">
                            First Name
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>

                        <Field
                          name="first_name"
                          type="text"
                          placeholder="First Name"
                          className={
                            "form-control" +
                            (errors.first_name && touched.first_name
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="first_name"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="last_name">
                            Last Name
                            <span className="mandatory">
                          <small>*</small>
                        </span></label>

                        <Field
                          name="last_name"
                          type="text"
                          placeholder="Last Name"
                          className={
                            "form-control" +
                            (errors.last_name && touched.last_name
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="last_name"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-md-8 col-lg-6 col-xl-6">
                      <div className="form-group">
                        <label htmlFor="system_role">
                           Assign System Roles
                            <span className="mandatory">
                          <small>*</small>
                        </span>{" "}(At least one is mandatory)</label>
                        <Select
                          mode="multiple"
                          style={{ width: '100%' }}
                          name="system_role"
                          disabled={userDetails && userDetails.role_id === 1}
                          onChange={this.handleInputSystemRole}
                          placeholder="Click here to select system roles"
                          value={this.state.system_role}
                          className={
                            (errors.system_role && touched.system_role
                              ? "is-invalid"
                              : "")
                          }
                        >
                          {userDetails && userDetails.role_id === 1 && DropDownData && DropDownData.role &&
                            DropDownData.role.filter((opt) => opt.role_id === 1).map((element, index) => (
                              <Option value={element.role_id}>
                                {element.role_name}
                              </Option>
                            ))}
                        {systemRoleOptions}
                        </Select>
                        <ErrorMessage
                          name="system_role"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="primary_system_role">
                           Primary System Role
                            <span className="mandatory">
                          <small>*</small>
                        </span></label>
                        <Field
                          as="select"
                          name="primary_system_role"
                          type="text"
                          disabled={this.state.system_role.length === 0 || (userDetails && userDetails.role_id === 1)}
                          className={
                            "form-control" +
                            (errors.primary_system_role && touched.primary_system_role
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        >
                            <option value="">Select Primary Role</option>
                         {primarySystemRoleOptions} 
                        </Field>
                        <ErrorMessage
                          name="primary_system_role"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-lg-12">
                      <h4>Privileges</h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-4 col-xl-3">
                    <div
                        className={`custom-control custom-checkbox ${style.recurringWrapper}`}
                      >
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="system_access"
                          name="system_access"
                          disabled={userDetails && userDetails.role_id === 1}
                          onChange={this.handleCheckbox}
                          checked={this.state.system_access === 1}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="system_access"
                        >
                          System Access
                        </label>
                      </div>
                    </div>
                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div
                        className={`custom-control custom-checkbox ${style.recurringWrapper}`}
                      >
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="approval_list_access"
                          name="approval_list_access"
                          checked={this.state.approval_list_access === 1}
                          onChange={this.handleCheckbox}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="approval_list_access"
                        >
                          Approval List Access
                        </label>
                      </div>
                    </div>
                
                    </div>
                </div>

                {this.state.system_role.length > 0 && 
                this.state.system_role.indexOf(2) > -1
                 && (
                 <div className="form-box-shadow mb-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4>Practitioner's Mediswitch Credentials</h4>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-lg-12">
                    <div
                        className={`custom-control custom-checkbox ${style.recurringWrapper}`}
                      >
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="isBillingPractitioner"
                          name="isBillingPractitioner"
                          onChange={this.handleCheckbox}
                          checked={this.state.isBillingPractitioner === 1}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="isBillingPractitioner"
                        >
                          Enable Credentials
                        </label>
                      </div>
                    </div>
                    </div>

                  <div className="row mt-1">
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="mediswitch_username">
                            Username
                        {this.state.isBillingPractitioner === 1 && (<span className="mandatory">
                          <small>*</small>
                        </span>)}</label>

                        <Field
                          name="mediswitch_username"
                          type="text"
                          placeholder="Username"
                          disabled={this.state.isBillingPractitioner === 0}
                          className={
                            "form-control" +
                            (errors.mediswitch_username && touched.mediswitch_username
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="mediswitch_username"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="mediswitch_password">
                            Password
                            {this.state.isBillingPractitioner === 1 && (<span className="mandatory">
                          <small>*</small>
                        </span>)}</label>

                        <Field
                          name="mediswitch_password"
                          type="password"
                          placeholder="Password"
                          disabled={this.state.isBillingPractitioner === 0}
                          className={
                            "form-control" +
                            (errors.mediswitch_password && touched.mediswitch_password
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="mediswitch_password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-6 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label htmlFor="package_code">
                            Package Code
                            {this.state.isBillingPractitioner === 1 && (<span className="mandatory">
                          <small>*</small>
                        </span>)}</label>

                        <Field
                          name="package_code"
                          type="text"
                          placeholder="Package Code"
                          disabled={this.state.isBillingPractitioner === 0}
                          className={
                            "form-control" +
                            (errors.package_code && touched.package_code
                              ? " is-invalid"
                              : "")
                          }
                          onChange={this.handleInputChange}
                        />
                        <ErrorMessage
                          name="package_code"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div> */}
                    
                    </div>
                </div>)}
               
                <div className="row">
                  <div className="col-md-12">
                    {this.state.isLoading ? (
                      <div className={style.loadingWrapper}>
                        <img src={ttmLoader} alt="loader" className={style.loading} />
                      </div>
                    ) : (
                      <div>
                        {this.state.successMessage && (
                          <p className={style.successMessage}>
                            {this.state.successMessage}
                          </p>
                        )}
                        {this.state.errorMessage && (
                          <p className={style.errorMessage}>
                            {this.state.errorMessage}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                <div className="col-lg-6 d-flex justify-content-md-start">
                    <div className={style.editAccBtnWrapper}>
                      <Button type="button" onClick={this.goBack} className="form-primary-btn">
                        Back
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className={style.editAccBtnWrapper}>
                      <Button type="submit" className="form-primary-btn">
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
    return {
      dropdownListData: state.dropdownList,
      userDetailsData: state.userDetails
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      fetchDropdownList: () => dispatch(fetchDropdownList()),
      fetchUserDetails: (user_id) => dispatch(fetchUserDetails(user_id)),
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(EditSystemUser);
  
